import * as S from "./styles";
import { useToken } from '../TokenContext';

import promoLogo from '../../assets/img/promoLogo.png';

export function InitialInfo() {
    const { tokenData } = useToken();
    return (
        <S.Container>
            {tokenData.tipo == 'participante' && (
                <div className="relative z-[1]">
                    <div className="absolute left-1/2 -top-40 -translate-x-1/2 w-screen h-[calc(100%_+_26em)] bg-primary -z-[1]" />

                    <img src={promoLogo} alt="Logo da promoção" className="mx-auto w-[160px] sm:w-[200px] 2xl:w-[250px] pt-24 sm:pt-40 2xl:pt-44 pb-8 sm:pb-12 brightness-0 invert pointer-events-none" />
                    
                    <h2 className="font-secondary-xt text-4xl 2xl:text-[45px] text-tertiary text-center font-semibold mb-6">Olá, {tokenData.nome}</h2>
                    <h4 className="bg-tertiary w-3/4 max-w-[400px] mx-auto text-primary text-2xl 2xl:text-[29px] text-center rounded-2xl p-2 pb-3">Você possui <span>{tokenData.pontosAtuais} {tokenData.pontosAtuais ? 'pontos' : 'ponto'}</span></h4>
                </div>
            )}
       </S.Container>
    );
}
